import axios from 'axios';

import AxiosFormatResponseStrategy from './interceptors/AxiosFormatResponseStrategy';
import AxiosRefreshTokenStrategy from './interceptors/AxiosRefreshTokenStrategy';
import AxiosImportantRequestRepeaterStrategy from './interceptors/AxiosImportantRequestRepeaterStrategy';
import AxiosPrefetchFailedRequestsStrategy from './interceptors/AxiosPrefetchFailedRequestsStrategy';
import AxiosRequestStrategy from './interceptors/AxiosRequestStrategy';
import AxiosVersionStrategy from './interceptors/AxiosVersionStrategy';

let apiToken = null;

/* eslint-disable no-use-before-define */
function repeatRequest(config) {
  const { headers, transformRequest, transformResponse, ...cfgs } = config;
  const instance = createApiInstance();
  const repeatHeaders = { ...headers, ...setAuthHeader(instance, apiToken) };

  return instance.request({ ...cfgs, headers: repeatHeaders });
}

const formatResponseStrategy = new AxiosFormatResponseStrategy();
const importantRequestRepeaterStrategy = new AxiosImportantRequestRepeaterStrategy(
  formatResponseStrategy,
  repeatRequest,
);
const refreshTokenStrategy = new AxiosRefreshTokenStrategy(
  importantRequestRepeaterStrategy,
  repeatRequest,
);
const reqStrategy = new AxiosRequestStrategy();
const preloadResourceStrategy = new AxiosPrefetchFailedRequestsStrategy(
  reqStrategy,
  importantRequestRepeaterStrategy,
);
const versionStrategy = new AxiosVersionStrategy(preloadResourceStrategy);

refreshTokenStrategy.on(AxiosRefreshTokenStrategy.EVENTS.TOKEN_UPDATED, setToken);
/* eslint-enable no-use-before-define */

export const applyInterceptors = (instance) => {
  instance.interceptors.request.use(
    (r) => versionStrategy.success(r),
    (err) => versionStrategy.fail(err),
  );
  instance.interceptors.response.use(
    (r) => refreshTokenStrategy.success(r),
    (err) => refreshTokenStrategy.fail(err),
  );
};

export const createApiInstance = (url) => {
  const urlConfigs = url ? { baseURL: url } : {};
  const instance = axios.create({
    timeout: 60000,
    ...urlConfigs,
  });

  applyInterceptors(instance);

  return instance;
};

const setAuthHeader = (instance, header) =>
  Object.assign(instance.defaults.headers, {
    Authorization: header,
  });

const removeAuthHeader = (instance) => {
  setAuthHeader(instance, null);
};

export const userDataApi = createApiInstance('https://user-data.fairview-ads.com');
export const targetingApi = createApiInstance('https://targeting.fairview-ads.com');
export const rewardsApi = createApiInstance('https://rewards.fairview-ads.com');
export const apiV1 = createApiInstance('https://api.fairview-ads.com/v1');
export const formsApi = createApiInstance('https://forms.fairview-ads.com');
export const userContextApi = createApiInstance('https://user-context.fairview-ads.com');

function modifyApiInstances(modificator, ...data) {
  [userDataApi, targetingApi, userContextApi, rewardsApi, apiV1, formsApi].forEach((instance) =>
    modificator(instance, ...data),
  );
}

export const setToken = (token) => {
  if (window.location.origin === 'https://rewards-user-authentication.web.app') {
    console.log('token', token);
  }

  apiToken = token;
  modifyApiInstances(setAuthHeader, token);
};

export const removeToken = () => {
  modifyApiInstances(removeAuthHeader);
};
